/* The header's panels: how they open, how they close, and what the page does
   underneath them.

   The platform opens a panel on a click only: to see what sits under Shop you
   first had to land on it. With a pointer that is an extra step, and every
   store the client pointed at opens on hover. So: a panel opens once the
   pointer has rested on its word for a moment (a pointer crossing the row on
   its way somewhere else opens nothing), it stays open while the pointer is
   anywhere over the word or the panel, and it closes a moment after the pointer
   has left both. A click keeps working as it did: it toggles, and a panel a
   click opened stays until the next click or Escape. Only one panel is open at
   a time. While one is, the page behind it steps back, so the panel reads as
   the thing in front rather than as more page.

   Nothing changes on a touch screen, where there is no hover: the phone has
   its own menu. */
(function () {
  var fine;
  try {
    fine = window.matchMedia('(hover: hover)').matches && window.matchMedia('(pointer: fine)').matches;
  } catch (e) { fine = false; }

  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 160;
  var root = document.documentElement;

  function paint() {
    /* The search is a panel as well: while it is open the page steps back
       the same way. */
    var open = document.querySelector('.sa-nav__details[open], .header__search details[open]');
    root.classList.toggle('sa-nav-open', !!open);
    var all = document.querySelectorAll('.sa-nav__details');
    Array.prototype.forEach.call(all, function (d) {
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    });
  }

  function wire(scope) {
    var list = scope.querySelectorAll('.sa-nav__details');
    if (!list.length) return;

    Array.prototype.forEach.call(list, function (d) {
      if (d.dataset.saWired) return;
      d.dataset.saWired = '1';
      var openTimer = null;
      var closeTimer = null;
      var byHover = false;

      function closeOthers() {
        Array.prototype.forEach.call(list, function (o) { if (o !== d && o.open) o.open = false; });
      }
      function open() {
        clearTimeout(closeTimer);
        if (d.open) return;
        closeOthers();
        byHover = true;
        d.open = true;
      }
      function close() {
        clearTimeout(openTimer);
        if (!byHover) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { d.open = false; byHover = false; }, CLOSE_DELAY);
      }

      d.addEventListener('toggle', paint);

      if (fine) {
        d.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          openTimer = setTimeout(open, OPEN_DELAY);
        });
        d.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          close();
        });
      }

      var sum = d.querySelector('summary');
      if (sum) {
        sum.addEventListener('click', function (e) {
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
          /* The first click on a panel the hover already opened hands it to the
             click and toggles nothing, or the panel would blink shut under the
             pointer that had only just been shown it. */
          if (byHover && d.open) {
            e.preventDefault();
            byHover = false;
            return;
          }
          byHover = false;
          if (!d.open) closeOthers();
        });
      }

      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) {
          d.open = false;
          byHover = false;
          if (sum) sum.focus();
        }
      });

      /* Tabbing out of the panel closes it; tabbing within it keeps it. */
      d.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !d.contains(e.relatedTarget)) { d.open = false; byHover = false; }
      });
    });

    /* A click anywhere else closes what is open. */
    if (!document.body.dataset.saNavDoc) {
      document.body.dataset.saNavDoc = '1';
      document.addEventListener('click', function (e) {
        if (e.target.closest('.sa-nav__details')) return;
        var open = document.querySelectorAll('.sa-nav__details[open]');
        Array.prototype.forEach.call(open, function (o) { o.open = false; });
      });
      /* The search opens and closes on its own; the scrim only has to know. */
      var search = document.querySelector('.header__search details');
      if (search) search.addEventListener('toggle', paint);
      /* The scrim is a way out as well. */
      var scrim = document.querySelector('.sa-nav-scrim');
      if (scrim) scrim.addEventListener('click', function () {
        var open = document.querySelectorAll('.sa-nav__details[open], .header__search details[open]');
        Array.prototype.forEach.call(open, function (o) {
          /* The search closes through its own element, which also lets go
             of the listeners it took on opening. */
          var modal = o.closest('details-modal');
          if (modal && typeof modal.close === 'function') modal.close(false);
          else o.open = false;
        });
      });
    }
    paint();
  }

  function start() { wire(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
